export interface ScenarioMapOption {
  value: string;
  label: string;
}

export type ScenarioMaps = {
  [key: string]: ScenarioMapOption[];
};

export interface SpawnPositionOption {
  value: string;
  label: string;
}

/**
 * Spawn positions per exposure map (value = id inviato al device).
 * Mappe assenti o con lista vuota: nessuno spawn da scegliere (default "1").
 */
export const exposureSpawnPositions: Record<string, SpawnPositionOption[]> = {
  pub: [
    { value: '1', label: 'Bancone' },
    { value: '2', label: 'Tavolino' },
  ],
  // TODO: label reali da Unreal
  disco: [
    { value: '1', label: 'Posizione 1' },
    { value: '2', label: 'Posizione 2' },
  ],
  casino: [
    { value: '1', label: 'Gaming desk area' },
  ],
};

export function getExposureSpawnPositions(
  map: string | undefined | null
): SpawnPositionOption[] {
  if (!map) return [];
  return exposureSpawnPositions[map] ?? [];
}

export const scenarioMaps: ScenarioMaps = {
  performance: [
    { value: 'volcano', label: 'Vulcano' },
    { value: 'ocean', label: 'Oceano' },
    { value: 'stadium', label: 'Stadio' },
  ],
  exposure: [
    { value: 'restaurant', label: 'Ristorante' },
    { value: 'kitchen', label: 'Cucina' },
    { value: 'bedroom', label: 'Camera da letto' },
    { value: 'dining_room', label: 'Sala da pranzo' },
    { value: 'pub', label: 'Pub' },
    { value: 'disco', label: 'Disco' },
    { value: 'casino', label: 'Casinò' },
  ],
};

/** Label UI per scenario/mappa — stessa fonte della dropdown form (`scenarioMaps`). */
export function getScenarioDisplayLabel(
  type: string | undefined | null,
  scenario: string | undefined | null,
  videoName?: string | null
): string {
  if (!scenario || scenario.trim() === '') return 'N/A';
  const trimmed = scenario.trim();
  if (trimmed === 'esperienza-vr') {
    return videoName?.trim() || trimmed;
  }

  const findLabel = (options: ScenarioMapOption[] | undefined) =>
    options?.find(
      option => option.value.toLowerCase() === trimmed.toLowerCase()
    )?.label;

  const fromType = findLabel(type ? scenarioMaps[type] : undefined);
  if (fromType) return fromType;

  for (const options of Object.values(scenarioMaps)) {
    const found = findLabel(options);
    if (found) return found;
  }

  return trimmed;
}
